import React, { useEffect, useState } from "react";
import moment from "moment";
// import { Layout, CustomAlerts } from "@hedgefund/shared";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import {
  getRegion,
  getStrategies,
  createFunds,
  getSpecialities,
} from "./actions";
import {
  Input,
  Button,
  Checkbox,
  // InputDropdown,
  Spinner,
} from "@public/ui-toolkit";
import { alertService } from "@hedgefund/shared/src/Alert";

const CreateFund = () => {
  const fundState = useSelector((state) => state.createFund);
  const dispatch = useDispatch();
  const [message, setMessage] = useState(null);
  const [isMSCILinked, setIsMSCILinked] = useState(false);
  const [regionId, setRegionId] = useState([]);
  const [value, setValue] = useState("");
  const [strategy, setStrategy] = useState();
  const [subSpeciality, setSubspeciality] = useState();
  const { region, strategies, loading, specialities, subLoading } =
    fundState || {};

  useEffect(() => {
    dispatch(getRegion());
    dispatch(getStrategies());
  }, []);

  useEffect(() => {
    if (value) {
      formik.setFieldValue("strategyId", value);
      handleSpeciality(value);
    }
  }, [value]);

  const onSuccess = () => {
    if (!fundState.loading) {
      setMessage(true);
    } else {
      setMessage(false);
    }
  };

  const onSuccessAlert = (val) => {
    alertService.success("Create Fund Successfully!", { autoClose: true });
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      initializationDate: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("No name provided."),
      initializationDate: Yup.string().required("Please select date."),
    }),
    onSubmit: (values) => {
      // const formData = new FormData();
      Object.assign(values, {
        regionIds: regionId.map((item) => item.id),
        isMSCILinked: isMSCILinked,
        strategyId: strategy,
        subSpecialtyId: subSpeciality,
      });

      dispatch(createFunds(values, onSuccessAlert));
      formik.resetForm();
    },
  });

  const regionIdHandler = (value) => {
    setRegionId(value);
  };

  const handleSpeciality = (value) => {
    dispatch(getSpecialities(value?.id, onSuccess), setStrategy(value?.id));
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      marginTop: "3px",
      height: "42px",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      fontSize: "12px",
    }),
    option: (base, state) => ({
      ...base,
      fontSize: "12px",
      color: "##878a88",
    }),
  };

  return (
    <main>
      {/* {message && !fundState.loading ? (
        <CustomAlerts
          alertMessage={"Create Fund Successfully!"}
          type="success"
        />
      ) : (
        ""
      )} */}
      <div className="main-inner align-items-center d-flex">
        <div className="container">
          {fundState.loading || !Object.keys(fundState).length ? (
            <Spinner />
          ) : (
            <div
              className="
            edit-profile-container
            p-xxl-5 p-md-4 p-3
            box-shadow
            bg-white
            rounded-large
          "
            >
              <div className="box-lg mt-5">
                <div className="row">
                  <div className="heading text-center justify-content-center pb-5 ">
                    <h2 className="text-blue">Request Fund Creation</h2>
                  </div>
                </div>

                <form onSubmit={formik.handleSubmit}>
                  <div className="mt-5">
                    <div className="row g-4">
                      <div className="col-md-6">
                        <span>Fund Name</span>
                        <Input
                          type="text"
                          placeholder="Fund Name"
                          id="name"
                          label="Fund Name"
                          forr="name"
                          {...formik.getFieldProps("name")}
                          props
                        />
                        {formik.touched.name && formik.errors.name ? (
                          <div className="form-error-message">
                            {formik.errors.name}
                          </div>
                        ) : null}
                      </div>

                      <div className="col-md-6">
                        <span>Select Region</span>
                        <Select
                          styles={customStyles}
                          placeholder="Select Region"
                          isMulti
                          isSearchable
                          options={region}
                          className="basic-multi-select input-group-addon"
                          classNamePrefix="select"
                          onChange={(e) => regionIdHandler(e)}
                        />
                      </div>
                      <div className="col-md-6 ">
                        <span>Select Strategy</span>
                        <Select
                          styles={customStyles}
                          placeholder="Select Strategy"
                          isSearchable
                          options={strategies}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={(e) => handleSpeciality(e)}
                        />
                      </div>
                      <div className="col-md-6 ">
                        <span>Select Sub Strategy</span>
                        <Select
                          isDisabled={strategy === undefined ? true : false}
                          styles={customStyles}
                          placeholder="Select Sub Strategy"
                          isSearchable
                          options={specialities}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          isLoading={subLoading}
                          onChange={(e) => setSubspeciality(e.id)}
                        />
                      </div>
                      <div className="col-md-6">
                        <span>Date of Initiation</span>
                        <Input
                          type="date"
                          placeholder="Date of Initiation"
                          max={moment().format("YYYY-MM-DD")}
                          id="initializationDate"
                          label="Date of Initiation"
                          forr="initializationDate"
                          {...formik.getFieldProps("initializationDate")}
                          props
                        />
                        {formik.touched.initializationDate &&
                        formik.errors.initializationDate ? (
                          <div className="form-error-message">
                            {formik.errors.initializationDate}
                          </div>
                        ) : null}
                      </div>
                      <div className="col-md-6  ">
                        <p>Is Fund linked with MSCI ?</p>
                        <div className="d-flex p-0">
                          <span>No</span>
                          <div className="form-switch ps-4 msci">
                            <Checkbox
                              label={"Yes"}
                              type="checkbox"
                              name="isMSCILinked"
                              id="isMSCILinked"
                              onChange={(e) => {
                                setIsMSCILinked(e.target.checked);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="text-center mt-5">
                      {/* <Button btnName="Cancel" btnType="!primary" /> */}
                      <Button
                        btnName="Submit"
                        btnType="primary"
                        type="submit"
                        onClick={formik.handleSubmit}
                        dataDismiss="modal"
                        loading={loading}
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default CreateFund;
